export default function SimpleTitle({title, children, loseContainer}) {
  return <>
    <section className={'container mx-auto'}>
      <h1 className={'text-gray-700 text-xl font-medium py-2 px-5 md:px-10'}>{title} </h1>
    </section>
    <div className="border-b"/>
    <section
        className={`mx-auto min-h-screen ${loseContainer ?
            '' :
            'container py-2 py-2 px-5 md:px-10'}`}>
      {children}
    </section>
  </>;

}